import React from 'react';
import style from './LoginRequired.module.css';

export const ISU_URL = 'https://isu.gstou.ru/';

/**
 * Библиотека доступна студентам и сотрудникам ГГНТУ после входа в ИСУ.
 * Раньше вместо этой страницы показывалось системное окно alert и сразу
 * происходил переход на isu.gstou.ru — без объяснения, куда и зачем.
 */
const LoginRequired = () => (
    <div className={style.wrap}>
        <div className={style.card}>
            <div className={style.icon} aria-hidden="true">
                <i className="fa fa-lock"></i>
            </div>
            <h1 className={style.title}>Войдите через ИСУ</h1>
            <p className={style.text}>
                Электронная библиотека ГГНТУ доступна студентам и сотрудникам университета.
                Войдите в информационную систему университета (ИСУ) — после этого
                библиотека откроется автоматически.
            </p>
            <a className={style.button} href={ISU_URL}>Войти через ИСУ</a>
            <p className={style.note}>
                Нет доступа или что-то не работает? Напишите на{' '}
                <a href="mailto:ebs_ggntu@mail.ru">ebs_ggntu@mail.ru</a>.
            </p>
        </div>
    </div>
);

export default LoginRequired;
